module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/cut-above-cfd3d08ab8ab8687c35dfe44ec2259ed.png";